module.exports = __webpack_public_path__ + "static/award-criticalfiles-189a6bb034f58dcbd98aa255d0b4a3c6.png";